import { render } from "./user_profile.vue?vue&type=template&id=b493a912"
import script from "./user_profile.vue?vue&type=script&lang=js"
export * from "./user_profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__